/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Max_Wpm_LabelInputs */



/**
* | output |
* | --- |
* | "Max Reading Rate" |
*
* @param {Ad_Max_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_max_wpm_label = /** @type {((inputs?: Ad_Max_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Max_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse de lecture maximale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Lesegeschwindigkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità di lettura massima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная скорость чтения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad máxima de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大阅读速率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大読書速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम पठन दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa máxima de leitura")
	return /** @type {LocalizedString} */ ("Max Reading Rate")
});